export default "__VITE_ASSET__qzNZu8Cu__"